import { withInstall } from '@zoryn/utils'
import ImageViewer from './src/image-viewer.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZImageViewer: SFCWithInstall<typeof ImageViewer> =
  withInstall(ImageViewer)
export default ZImageViewer

export * from './src/image-viewer'
